import Lottie from "lottie-react";
import animationData from "./data.json";
import './Loader.scss';

const Loader = () => <div className="global-loader"><Lottie animationData={animationData} loop={true} autoplay={true} /></div>;

export default Loader;
